import React, { useState } from "react";
import AddButton from "components/Buttons/AddButton";
import AddPageModal from "components/modal/AddPageModal";
import { createPage } from "api";
import { useGlobalContext } from "context/GlobalContext";
import { useParams } from "react-router-dom";

const EmptyPage = ({ type }) => {
  const { setDesignSystemMeta, setLoading } = useGlobalContext();
  const [isAddPageModalOpen, setAddPageModalOpen] = useState(false);
  const { id } = useParams();
  // Add page
  const openAddPageModal = () => {
    setAddPageModalOpen(true);
  };
  const closeAddPageModal = () => {
    setAddPageModalOpen(false);
  };
  const handleAddPageApply = async (name) => {
    const dataToSubmit = {
      name,
      content: "",
      type: type,
      design_system_id: id,
    };

    try {
      setLoading(true);
      const data = await createPage(dataToSubmit);
      setDesignSystemMeta((prevState) => ({
        ...prevState,
        pages: Array.isArray(prevState.pages)
          ? [...prevState.pages, data.data]
          : [data.data],
      }));
    } catch (error) {
      console.error("Failed to create page:", error.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="plt-contents-container w-100">
      <div className="d-flex justify-content-center">
        <div className="d-flex align-items-center">Add section</div>
        <div onClick={openAddPageModal}>
          <AddButton />
        </div>
        <AddPageModal
          isOpen={isAddPageModalOpen}
          onRequestClose={closeAddPageModal}
          onApply={handleAddPageApply}
          title={"Add section"}
        />
      </div>
    </div>
  );
};

export default EmptyPage;
